// Client env — the SPA-native counterpart to apps/web's env.ts (zod-validated
// server env, stays in apps/server). Mirrors Next's NEXT_PUBLIC_ inlining
// semantics via Vite's native VITE_ prefix (FRONTEND_SPA_DESIGN.md §5b).
// Thin typed passthrough deliberately, not a zod schema yet — upgrade once
// the G1 batch needs fail-fast-on-boot validation.
//
// NOTE: this is for NEW spa-authored code (like routes/__root.tsx). Reused
// apps/web files keep reading `process.env.NEXT_PUBLIC_*` — those are
// served by the wholesale define-shim in vite.config.ts, not this module.
export const env = {
  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? '',
  posthogKey: import.meta.env.VITE_POSTHOG_KEY ?? '',
  posthogHost: import.meta.env.VITE_POSTHOG_HOST ?? '',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  appUrl: import.meta.env.VITE_APP_URL ?? window.location.origin,
  chatExecutionMode: import.meta.env.VITE_CHAT_EXECUTION_MODE ?? 'direct',
  canvasModeEnabled: import.meta.env.VITE_CANVAS_MODE_ENABLED === 'true',
  reactScan: import.meta.env.VITE_REACT_SCAN === 'true',
} as const;
